export const ENABLE_CROSS_SELLING_FIELD_NAME = 'enableCrossSelling';
export const CROSS_SELL_SETTINGS_FIELD_NAME = 'CrossSellSettings';
/** Account preference: base URL of the Activities front for cross-app deep-links. */
export const ACTIVITIES_BASEADDRESSSITE_FIELD_NAME = 'activitiesBaseAddressSite';

export interface ICrossSellSettings {
  IsActiveCrossSellActivity: boolean;
  IsActiveCrossSellCar: boolean;
  IsActiveCrossSellHotel: boolean;
  IsActiveCrossSellCondo: boolean;
  IsActiveCrossSellPropertyV2: boolean;
  IsActiveDestinationCarCity: boolean;
  IsActiveDestinationCarAirport: boolean;
  IsActiveDestinationActivityCity: boolean;
  IsActiveDestinationHotelCity: boolean;
  IsActiveDestinationCondoCity: boolean;
  IsActiveFilterByAvailability: boolean;
  KeepOnAvailabilityError: boolean;
  targetClubs?: ICrossSellTargetClub[];
}

/**
 * A cross-sell target scope for RSI accounts. At least one of `orgId`/`siteId`
 * is present; a club matches when every id it specifies matches the current scope.
 */
export interface ICrossSellTargetClub {
  orgId?: string;
  siteId?: string;
}
